export function ErklaerungLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-teal-600 text-white flex items-center justify-center font-bold">
              FOM
            </div>
            <div>
              <div className="font-semibold text-slate-900">FOM Hochschule</div>
              <div className="text-xs text-slate-500">Erklärung zur Kostentragung</div>
            </div>
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-8">
        {children}
      </main>
      <footer className="max-w-3xl mx-auto px-6 py-4 text-xs text-slate-400 text-center">
        © FOM Hochschule — Digitalisierte Erklärung über das MyFOM Partnerportal
      </footer>
    </div>
  );
}
